/**
 * Parameter Narrative Modal - Display full ReefZelements narrative text
 * Opens as a right-side drawer on desktop, full-screen on mobile
 */
import { Drawer, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

interface ParameterNarrativeModalProps {
  isOpen: boolean;
  parameterName: string;
  narrativeText: string | null;
  onClose: () => void;
}

export function ParameterNarrativeModal({
  isOpen,
  parameterName,
  narrativeText,
  onClose,
}: ParameterNarrativeModalProps) {
  // Responsive: full-screen on mobile, 50% width on desktop
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Drawer
      opened={isOpen}
      onClose={onClose}
      position="right"
      size={isMobile ? 'full' : '50%'}
      title={
        <Title order={3} size="h4">
          {parameterName}
        </Title>
      }
      closeOnClickOutside
      closeOnEscape
      overlayProps={{ opacity: 0.5, blur: 4 }}
      styles={{
        body: {
          padding: '1.5rem',
        },
      }}
      // Accessibility attributes
      aria-label={`Narrative information for ${parameterName}`}
    >
      {narrativeText ? (
        <Text
          style={{
            whiteSpace: 'pre-line', // Preserve paragraph breaks
            lineHeight: 1.6,
            fontSize: '0.95rem',
          }}
        >
          {narrativeText}
        </Text>
      ) : (
        <Text c="dimmed" fs="italic">
          No narrative information available for this parameter.
        </Text>
      )}
    </Drawer>
  );
}
